export default {
  name: 'Preview',
  path: '/preview',
  meta: {
    title: 'router.preview'
  }
};
